import renderComponent from '../render_component';
import App from '../components/self_signup/enrols/app.vue';
import Vue from 'vue/dist/vue.esm';

Vue.directive('tooltip', function (el, binding) {
  $(el).tooltip({
    title: binding.value,
    placement: binding.arg,
    trigger: 'hover',
  });
});
renderComponent('#app', { App });

const EventBus = new Vue();

window.SSBC = { ...window.SSBC, EventBus };
